module.exports = __webpack_public_path__ + "img/sydwfrzs_yl_img.ad5b9d6b.png";